<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                <v-row>
                    <v-col cols="12" sm="7" md="7" class="pb-n5" v-if="!this.formData.lockstaff">
                        <v-autocomplete
                            outlined
                            :label="this.$t('setupepf.epfgroup')"
                            type="text"
                            dense
                            v-model="formData.epfgroupid"
                            :items="epfGroupList"
                            @change="changeEPFGroupHandler(formData.epfgroupid)"
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="7" md="7" class="pb-n5" v-else>
                        <v-autocomplete
                            outlined
                            :label="this.$t('setupepf.epfgroup')"
                            type="text"
                            dense
                            v-model="formData.epfgroupid"
                            :items="epfGroupList"
                            readonly
                            background-color="#ffeab2"
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="1" sm="1" class="pb-n5">
                        <v-dialog v-model="epfgroupDialog" max-width="600px" persistent>
                            <template v-slot:activator="{ on }">
                                <v-btn dense v-on="on">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <app-genericform 
                                    v-bind:parentData = "{
                                        tabItems: epfGroupItems,
                                        formTitle: `${this.$t('setupepf.epfgroupsetup')}`,
                                        formId: 'epfgroupsetup'
                                    }"

                                    v-on:input="itemData = $event"
                                    v-on:saveEPFGroup="saveEPFGroupHandler"
                                    v-on:deleteEPFGroup="deleteEPFGroupHandler"
                                />

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="warning"
                                        text
                                        @click="epfgroupDialog = false"
                                    >
                                        {{$t('button.close')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            background-color="#ffeab2"
                            readonly
                            :label="this.$t('columns.description')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.epfgroupdesc"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('columns.effectivefrom')"
                            type="date"
                            ref="startdate"
                            :rules="[rules.required]"
                            v-model="formData.startdate"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('columns.effectiveuntil')"
                            type="date"
                            ref="enddate"
                            :rules="[rules.required]"
                            v-model="formData.enddate"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                        <v-textarea
                            outlined
                            :label="this.$t('columns.remark')"
                            type="text"
                            v-model="formData.remark"
                            @input="updateValue"
                            dense
                        ></v-textarea>
                    </v-col>
                </v-row>
                

                <v-row>
                    <v-col cols="12" style="padding: 0;">
                        <app-table 
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.formData.epfdetails
                            }"
                            v-on:input="addItemHandler"
                        />
                    </v-col>
                </v-row>

                </v-container>

                <div v-if="isErr">
                    <app-error
                        v-bind:parentError="{
                            data: this.errMsg,
                            isErr: this.isErr
                        }"
                        v-on:closeError="isErr = $event"
                    />
                </div>


                <div v-if="isErr">
                    <app-error
                        v-bind:parentError="{
                            data: this.errMsg,
                            isErr: this.isErr
                        }"
                        v-on:closeError="isErr = $event"
                    />
                </div>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit

                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>

        </v-container>
    </div>
</template>

<script>

import CRUDTable from './CRUDTable';
import GenericForm from '../../generic/GridForm';
import ErrorDialog from "../../common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
        'app-genericform': GenericForm,
        'app-error': ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },

            formData: {
                epfgroupid : this.parentObject.data.epfgroupid,
                epfgroupcode: this.parentObject.data.epfgroupcode,
                epfgroupdesc: this.parentObject.data.epfgroupdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                remark: this.parentObject.data.remark,
                epfdetails: this.parentObject.data.epfdetails,
                lockstaff: this.parentObject.data.lockstaff,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
            
            //app-table headers 
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.company'), value: 'compnyname', width: '150px', sortable: true},
                { text: this.$t('columns.employmenttype'), value: 'emptypedesc', width: '180px', sortable: true},
                { text: this.$t('reporalertlisting.age'), value: 'age', width: '100px', sortable: true},
                { text: this.$t('columns.gender'), value: 'gendername', width: '120px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '150px', sortable: true},
                { text: this.$t('setupepf.serviceperiod'), value: 'serviceperiod', width: '150px', sortable: true},
                { text: this.$t('setupepf.wages'), value: 'wages', width: '200px', sortable: true},
                { text: this.$t('setupepf.eepercentage'), value: 'ee_percent', width: '150px', sortable: true},
                { text: this.$t('setupepf.eeamount'), value: 'ee_amount', width: '200px', sortable: true},
                { text: this.$t('setupepf.erpercentage'), value: 'er_percent', width: '150px', sortable: true},
                { text: this.$t('setupepf.eramount'), value: 'er_amount', width: '200px', sortable: true},
            ],

            epfgroupDialog: false,

            epfGroup: [],
            epfGroupList: [],
            epfGroupItems: [],

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
             search: this.parentObject.searchnew
        }
    },

    methods: {

        loadEPFGroupListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/epfsetup/all'})
                .then(res => {
                    vm.epfGroup = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.epfGroupList.push(
                            {
                                text: res.data.rec[i].epfgroupcode,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.epfGroupItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].epfgroupcode,
                                desc: res.data.rec[i].epfgroupdesc,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },
        
        addItemHandler($event) {
            this.formData.epfdetails=$event

            this.updateValue();
        },  

        updateValue() {

            this.$emit('input', {
                epfgroupid: this.formData.epfgroupid,
                epfgroupcode: this.formData.epfgroupcode,
                epfgroupdesc: this.formData.epfgroupdesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                remark: this.formData.remark,
                epfdetails: this.formData.epfdetails,
                lockstaff: this.formData.lockstaff,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        saveEPFGroupHandler() {
            const vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/epfsetup/' + this.itemData.itemid, 
                    payload: {
                        epfgroupcode: this.itemData.itemcode,
                        epfgroupdesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.formData.userid
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.epfGroup = [];
                        vm.epfGroupItems = [];
                        vm.epfGroupList = [];

                        this.loadEPFGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/epfsetup/create', 
                    payload: {
                        epfgroupcode: this.itemData.itemcode,
                        epfgroupdesc: this.itemData.itemdesc,
                        userid: this.formData.userid
                    }})
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.epfGroup = [];
                        vm.epfGroupItems = [];
                        vm.epfGroupList = [];

                        this.loadEPFGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteEPFGroupHandler($event) {
            const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/epfsetup/' + $event.id + '/' + this.formData.userid})
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.epfGroup = [];
                        vm.epfGroupItems = [];
                        vm.epfGroupList = [];

                        this.loadEPFGroupListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }

        },

        changeEPFGroupHandler(id) {
            let item = this.epfGroup.find(item => item.id === parseInt(id));
            
            this.formData.epfgroupcode = item.epfgroupcode;
            this.formData.epfgroupdesc = item.epfgroupdesc;
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        //go to epfsetuplist
        cancelHandler() {
            this.$router.push({name: 'epfsetuplist', params: { search: this.search}});
        },
    },

    mounted() {
        this.loadEPFGroupListHandler();
        if (this.parentObject.isEdit){
            this.duplicateStaffData = this.formData;
            
            if (this.parentObject.data.lockstaff == "N") {
                this.formData.lockstaff = false;
            } else {
                this.formData.lockstaff = true;
            }
        }
    }
}
</script>